import { render } from "./TargetCategory.vue?vue&type=template&id=7280a655&bindings={\"categoryTargets\":\"data\",\"error\":\"data\",\"params\":\"data\",\"isEditable\":\"options\",\"addNewTarget\":\"options\",\"saveTargets\":\"options\",\"fetchCategoryTargets\":\"options\",\"setErrorMessage\":\"options\"}"
import script from "./TargetCategory.vue?vue&type=script&lang=js"
export * from "./TargetCategory.vue?vue&type=script&lang=js"
script.render = render

export default script